import { clsx } from 'clsx';
import { type ReactNode } from 'react';
import { badgeV2, badgeV2Tones } from './badge-v2.css.ts';

export type BadgeV2Tone = keyof typeof badgeV2Tones;

export const BadgeV2 = ({
  tone,
  children,
  className,
}: {
  tone: BadgeV2Tone;
  children: ReactNode;
  className?: string;
}) => (
  <span className={clsx(badgeV2, badgeV2Tones[tone], className)}>
    {children}
  </span>
);
